import React from 'react';
import { Helmet } from 'react-helmet';

export default function Seo({title, description, path='/', schema}) {
  const url = `https://technoration.net${path}`;
  const fullTitle = `${title} | Technoration Limited`;
  const image='https://technoration.net/social/technoration-share-v1.png';
  const imageAlt='Technoration Limited — Smart Solutions, Endless Generations. Custom software, AI and automation, web, mobile and cloud solutions.';
  return <Helmet>
    <title>{fullTitle}</title><meta name="description" content={description}/>
    <meta name="robots" content="index, follow, max-image-preview:large"/>
    <link rel="canonical" href={url}/>
    <meta property="og:type" content="website"/><meta property="og:title" content={fullTitle}/>
    <meta property="og:description" content={description}/><meta property="og:url" content={url}/>
    <meta property="og:site_name" content="Technoration Limited"/>
    <meta property="og:locale" content="en_GB"/>
    <meta property="og:image" content={image}/>
    <meta property="og:image:secure_url" content={image}/>
    <meta property="og:image:type" content="image/png"/>
    <meta property="og:image:width" content="1731"/>
    <meta property="og:image:height" content="909"/>
    <meta property="og:image:alt" content={imageAlt}/>
    <meta name="twitter:card" content="summary_large_image"/>
    <meta name="twitter:title" content={fullTitle}/>
    <meta name="twitter:description" content={description}/>
    <meta name="twitter:image" content={image}/>
    <meta name="twitter:image:alt" content={imageAlt}/>
    {process.env.REACT_APP_GOOGLE_SITE_VERIFICATION && <meta name="google-site-verification" content={process.env.REACT_APP_GOOGLE_SITE_VERIFICATION}/>}
    {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
  </Helmet>;
}
